module.exports = __webpack_public_path__ + "static/img/dd-partner-09.3d99938.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-partner-09.jpg
// module id = 9Ose
// module chunks = 1